import { Vector2 } from '@seddi/three';
import { updateGraphicTransform } from '@/store/appSlice';
const DRAG_THRESHOLD = 0.005;
export class TransformControls {
    constructor(canvas, raycaster, dispatch) {
        this.enabled = true;
        this.logos = [];
        this.isDown = false;
        this.isDrag = false;
        this.pointer = new Vector2();
        this.pointerDown = new Vector2();
        this.canvas = canvas;
        this.raycaster = raycaster;
        this.dispatch = dispatch;
        this.transform0 = {
            logoId: '',
            meshId: '',
            translation: new Vector2(),
            translationOffset: new Vector2(),
        };
        const scope = this;
        this.onPointerDown = function (event) {
            var _a;
            if (event.button !== 0)
                return; // Ignore right-click; logos never interact on right-click
            const { logos, selection, raycaster, transform0 } = scope;
            const { hit } = raycaster;
            if (hit.logoId && selection === hit.logoId) {
                scope.isDown = true;
                scope.pointerDown.copy(scope.pointer);
                transform0.logoId = hit.logoId;
                transform0.meshId = (_a = hit.meshId) !== null && _a !== void 0 ? _a : '';
                const logo = logos.find(l => l.id === hit.logoId);
                if (logo) {
                    transform0.translation.set(logo.transform.translation.x, logo.transform.translation.y);
                    transform0.translationOffset.copy(transform0.translation).sub(hit.uv);
                }
                canvas.setPointerCapture(event.pointerId);
                canvas.addEventListener('pointerup', onPointerUp);
            }
        };
        this.onPointerMove = function (event) {
            if (!scope.isDown)
                return;
            scope.pointer.x = (event.offsetX / canvas.clientWidth) * 2 - 1;
            scope.pointer.y = -(event.offsetY / canvas.clientHeight) * 2 + 1;
            if (scope.isDown && !scope.isDrag) {
                scope.isDrag = scope.pointerDown.distanceTo(scope.pointer) > DRAG_THRESHOLD;
            }
            if (!scope.isDrag)
                return;
            const { logos, transform0 } = scope;
            const hit = scope.raycaster.hit;
            const logo = logos.find(l => l.id === transform0.logoId);
            if (!logo)
                return;
            const translationMove = new Vector2();
            if (hit.meshId === transform0.meshId) {
                translationMove.copy(transform0.translationOffset).add(hit.uv);
            }
            else {
                translationMove.copy(transform0.translation);
            }
            const { translation } = logo.transform;
            if (Math.abs(translationMove.x - translation.x) > 1e-6 ||
                Math.abs(translationMove.y - translation.y) > 1e-6) {
                dispatch(updateGraphicTransform({
                    id: transform0.logoId,
                    translation: { x: translationMove.x, y: translationMove.y },
                }));
            }
        };
        function onPointerUp(event) {
            try {
                canvas.releasePointerCapture(event.pointerId);
            }
            catch (_a) {
                // Capture may have been released by PickControls
            }
            canvas.removeEventListener('pointerup', onPointerUp);
            scope.isDown = false;
            scope.isDrag = false;
        }
    }
    dispose() { }
}
